import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';

import { resolve } from '../../../utils/object/pathResolver';
const StaticPostcode = ({ fields, defaultValue }) => {
  return (
    <div className="vds-form__group vds-form__group--limited-width">
      <Text
        tag="label"
        htmlFor={fields.name?.value}
        className="vds-form__label "
        field={fields.label}
      />
      <label className="vds-form__label">{defaultValue}</label>
    </div>
  );
};
const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    defaultValue = resolve(reduxValuePath, state);
  }
  return {
    ...props,
    defaultValue,
  };
};
export default connect(mapStateToProps)(StaticPostcode);
